import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ia-view-shell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardNavbar = _resolveComponent("DashboardNavbar")!
  const _component_IAChatPanel = _resolveComponent("IAChatPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DashboardNavbar, {
      "site-name": _ctx.siteName,
      "site-logo-url": _ctx.siteLogoUrl,
      "logo-text": _ctx.logoText,
      "user-name": _ctx.userName,
      "user-avatar": _ctx.userAvatar,
      "user-username": _ctx.currentUsername,
      "notification-count": 0,
      "ia-mode": true,
      onIaMode: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.back())),
      onProfile: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/profile'))),
      onLogout: _ctx.handleLogout,
      onAnotacoes: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/anotacoes')))
    }, null, 8, ["site-name", "site-logo-url", "logo-text", "user-name", "user-avatar", "user-username", "onLogout"]),
    _createVNode(_component_IAChatPanel)
  ]))
}